import { render, staticRenderFns } from "./homeThree.vue?vue&type=template&id=ba3bbac2&scoped=true"
import script from "./homeThree.vue?vue&type=script&lang=js"
export * from "./homeThree.vue?vue&type=script&lang=js"
import style0 from "./homeThree.vue?vue&type=style&index=0&id=ba3bbac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3bbac2",
  null
  
)

export default component.exports